import axios from 'axios';
import { inspect } from 'util';

import { RequestProps } from '../index.types';

export const interceptor = async (req: { headers: RequestProps; originalUrl: string }, resolvedUrl: string) => {
  const { log } = global.loggerInstance('Interceptor');
  log.error(`Preprocessor Interceptor req: ${inspect(req)}`);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const headers: any = {
    Cookie: req.headers['cookie'],
    // Adding process.env['NEXT_PUBLIC_URL'] for localhost and x-host for higher envs.
    'X-Host': req.headers['x-host'] ?? process.env['NEXT_PUBLIC_URL'],
    'Content-Type': 'application/json',
    'Accept-Language': req.headers['accept-language'] ?? 'en-US',
    'x-request-id': req?.headers['x-request-id'] || '',
  };
  log.error(`Preprocessor Interceptor headers: ${inspect(headers)}`);
  const url = `${process.env['INTERCEPTOR_HOST_URL']}${process.env['INTERCEPTOR_URL']}`;
  log.error(`Preprocessor Interceptor API url: ${url}`);
  log.error(`Preprocessor Interceptor req.originalUrl: ${req.originalUrl}`);
  log.error(`Preprocessor Interceptor resolvedUrl: ${resolvedUrl}`);
  const originalRequestPath = req.originalUrl ?? resolvedUrl;
  log.error(`Preprocessor Interceptor originalRequestPath: ${originalRequestPath}`);
  const appId = process.env['NEXT_PUBLIC_APP_INTERCEPTOR_ID']; // add extra optionl params for account
  log.error(`Preprocessor Interceptor appID: ${appId}`);

  let response;
  try {
    response = await axios.post(
      url,
      {
        originalRequestPath,
        ...(appId ? { appId: appId } : {}), // add extra optionl params for account
      },
      { headers }
    );
  } catch (e) {
    log.error(`Interceptor API call failed: ${e}`);
    throw new Error('Interceptor call failed');
  }
  log.error('Interceptor data loaded');
  return response;
};
